import Cookies from 'js-cookie';
import { DateTime } from 'luxon';

/**
 * Interface for analytics session id store implementation, broken up to make logic more testable.
 */
export interface AnalyticsSessionIdStore {
  retrieveAnalyticsSessionId(): string | null;
  storeAnalyticsSessionId(id: string): void;
  refreshAnalyticsSession(): void;
}

/**
 * Storing analytics session id as a cookie allows backend to use the same analytics session id.
 * Also we get expiry for free.
 */
export class CookieAnalyticsSessionIdStore implements AnalyticsSessionIdStore {
  private cookieName: string;
  private cookieExpiryMinutes: number;
  constructor(cookieName: string, expiryMinutes: number) {
    this.cookieName = cookieName;
    this.cookieExpiryMinutes = expiryMinutes;
  }
  retrieveAnalyticsSessionId() {
    return Cookies.get(this.cookieName) || null;
  }

  storeAnalyticsSessionId(id: string) {
    Cookies.set(this.cookieName, id, {
      expires: DateTime.now().plus({ minutes: this.cookieExpiryMinutes }).toJSDate(),
    });
  }

  refreshAnalyticsSession() {
    const id = this.retrieveAnalyticsSessionId();
    if (id != null) {
      this.storeAnalyticsSessionId(id);
    }
  }
}
